import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOperationGetAvailableStatusesQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OperationStatusType } from 'api/types/entity/operation';
import { lodash } from 'helpers';

export const useOperationGetAvailableStatuses = (operationId: string) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOperationGetAvailableStatusesQuery({
    variables: { id: operationId },
  });
  const error = useError(apolloError);

  const availableStatuses = useMemo(
    () =>
      lodash
        .compact(data?.availableStatuses)
        .map((status) => OperationStatusType[status]),
    [data?.availableStatuses]
  );

  return {
    availableStatuses,
    loading,
    error,
  };
};
